import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApiError } from '../../../orval-gen/models';

@Injectable({
  providedIn: 'root',
})
export class HelpersService {
  // Marks the controls a hub 422 names, by the `body.<field>` location of each of its errors. Returns whether any
  // control was marked, so the caller can fall back to the error's `detail` when none of them is on the form.
  handleApiErrors(form: FormGroup, error: ApiError | null | undefined): boolean {
    let marked = false;
    for (const { location, message } of error?.errors ?? []) {
      const control = location?.startsWith('body.')
        ? form.get(location.slice('body.'.length))
        : null;
      if (control) {
        control.setErrors({ apiError: message ?? 'Invalid value.' });
        control.markAsTouched();
        marked = true;
      }
    }
    return marked;
  }
}
